<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'modals.ration.create.title' | translate }}
    v-card-title
    v-card-actions
      v-text-field.mb-3(
        :label="$t('base.name')"
        v-model="form.name")
      v-text-field.mb-3(
        :label="$t('base.code_1c')"
        v-model="form.code_1c")
      v-text-field(
        :label="$t('base.note')"
        v-model="form.comment")

    v-card-actions
      v-btn(
        :disabled="!isNameValid"
        :loading="loading"
        @click="onCreate") {{ 'actions.create' | translate }}

</template>

<script>
export default {
  name: 'CreateRationModal',

  data: () => ({
    form: {
      name: null,
      comment: null,
      code_1c: null
    },
    loading: false
  }),

  methods: {
    async onCreate () {
      this.loading = true
      const payload = {
        ...this.form
      }
      const { data, error } = await this.$store.dispatch('createRation', payload)
      this.loading = false
      if (error) {
        for (const key in data) {
          for (const msg of data[key]) {
            this.$toasted.show(this.$t(`errors.${key}.${msg}`), {
              position: 'bottom-center',
              duration: 5000
            })
          }
        }
      } else {
        this.$emit('close')
      }
    }
  },

  computed: {
    isNameValid () {
      return this.form.name &&
        this.form.name.length
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
